export const defaultUnsupportedWhitelistedTokens = {
  "name": "VVS Unsupported List",
  "timestamp": "2021-01-05T20:47:02.923Z",
  "version": {
    "major": 1,
    "minor": 0,
    "patch": 0
  },
  "tags": {},
  "logoURI": "",
  "keywords": ["vvs", "unsupported"],
  "tokens": []
}

export const getUnsupportedWhitelistedTokens = () => defaultUnsupportedWhitelistedTokens
